<template>
  <ul class="c-header-nav-more-social">
    <app-header-nav-more-social-item v-for="(social, index) in socials" :key="index" :social="social" />
  </ul>
</template>

<script>
import AppHeaderNavMoreSocialItem from "components/AppHeader/AppHeaderNav/AppHeaderNavMore/AppHeaderNavMoreSocial/AppHeaderNavMoreSocialItem";
export default {
  components: {
    AppHeaderNavMoreSocialItem
  },
  data() {
    return {
      socials: [
        {
          name: "facebook",
          title: "facebook",
          url: "https://www.facebook.com/economiesocialeQc/"
        },
        {
          name: "instagram",
          title: "instagram",
          url: "https://www.instagram.com/mois_economiesociale/"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.c-header-nav-more-social {
  @include reset-list;
  display: flex;
  flex-direction: row;
  width: 100%;
  @media #{$breakpoint-horizontal} {
    width: auto;
  }
}
</style>
